import { render } from "./ManageTechniciansGroupRelationModal.vue?vue&type=template&id=0fc00156"
import script from "./ManageTechniciansGroupRelationModal.vue?vue&type=script&lang=js"
export * from "./ManageTechniciansGroupRelationModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__